var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94157 18.0191L17.3978 12.427L9.94157 6.83483V18.0191ZM12.427 0C5.56728 0 0 5.56728 0 12.427C0 19.2867 5.56728 24.8539 12.427 24.8539C19.2867 24.8539 24.8539 19.2867 24.8539 12.427C24.8539 5.56728 19.2867 0 12.427 0ZM12.427 22.3685C6.94667 22.3685 2.48539 17.9073 2.48539 12.427C2.48539 6.94667 6.94667 2.48539 12.427 2.48539C17.9073 2.48539 22.3685 6.94667 22.3685 12.427C22.3685 17.9073 17.9073 22.3685 12.427 22.3685Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c21b8a4a7a41ba570a5b7447af95f8cf.svg";
export { ForwardRef as ReactComponent };